import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface EftpayMethod {
  type: string;
  wallet: string;
  label: string;
  icon: string;
}

export type PaymentMode = 'ONLINE' | 'MANUAL';

@Component({
  selector: 'app-checkout-payment',
  templateUrl: './checkout-payment.component.html',
  styleUrls: ['./checkout-payment.component.scss']
})
export class CheckoutPaymentComponent {
  @Input() paymentMode: PaymentMode = 'ONLINE';
  @Input() methods: EftpayMethod[] = [];
  @Input() selectedMethod: EftpayMethod | null = null;

  @Output() paymentModeChange = new EventEmitter<PaymentMode>();
  @Output() selectedMethodChange = new EventEmitter<EftpayMethod>();
  @Output() submit = new EventEmitter<void>();

  setMode(mode: PaymentMode): void {
    if (mode === this.paymentMode) return;
    this.paymentMode = mode;
    this.paymentModeChange.emit(mode);
  }

  selectMethod(m: EftpayMethod): void {
    this.selectedMethod = m;
    this.selectedMethodChange.emit(m);
  }

  isSelected(m: EftpayMethod): boolean {
    return !!this.selectedMethod && this.selectedMethod.wallet === m.wallet;
  }

  onSubmit(): void {
    this.submit.emit();
  }
}
